module.exports = __webpack_public_path__ + "assets/img/FusionCenter.13c034bd.png";